import ProgressIcon from "../../../assets/icons/pay-method-icons/progress-icon";
import ProgressBar from "./progress-bar";

const Component3 = ({
  value,
  latePayment,
  SuccessPercent,
  progressPercent,
}) => {
  return (
    <div className="w-full h-[160px] bg-[var(--list-payMet-card-bg)] p-[12px] rounded-[12px] flex flex-col  ">
      <div className="flex justify-between">
        <label className="font-[var(--trans-stats-con-value-fw)] text-[length:var(--trans-stats-con-value1-fs)] leading-4 align-middle text-[var(--bill-list-payMet-desc-fg)] mb-[8px]">
          Payment Success Rate
        </label>{" "}
        <ProgressIcon />
      </div>
      <div>
        <div className="flex space-x-[4px] ">
          <label className="font-[var(--trans-stats-con-label1-fw)] text-[length:var(--trans-stats-con-label1-fs)]] leading-6 align-middle ">
            {value}%
          </label>
          <label className="font-[var(--trans-stats-con-value-fw)] text-[length:var(--trans-stats-con-label-fs)] leading-6 align-middle text-[var(--trans-stats-con-blue-fg)]">
            On-Time
          </label>
        </div>
        <div className="mb-[23px]">
          <label style={{ color: "#EF4444 " }}>
            {latePayment} Late Payments
          </label>
        </div>
      </div>
      <div className="flex flex-row  justify-between  text-[length:var(--trans-stats-con-label-fs)] leading-[16px] font-[var(--trans-stats-con-value-fw)]">
        <label className="  align-middle">Success Rate</label>
        <label>
          <span className="text-[var(--trans-stats-con-blue-fg)]">
            {SuccessPercent}%
          </span>
        </label>
      </div>
      <ProgressBar
        value={progressPercent}
        progressColor={"#6366F1"}
        divClass="mb-[20px] mt-[4px]"
      />
    </div>
  );
};

export default Component3;
